// src/components/business/BusinessPageLayout.tsx
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { ThemeToggle } from '@/components/common/ThemeToggle';

interface Props {
  title: string;
  children: React.ReactNode;
  headerRight?: React.ReactNode;
}

const BusinessPageLayout: React.FC<Props> = ({ title, children, headerRight }) => {
  const navigate = useNavigate();
  const { businessId } = useParams<{ businessId: string }>();

  return (
    <div className="min-h-screen bg-light-bg dark:bg-dark-bg">
      {/* Header */}
      <div className="sticky top-0 z-40 bg-light-card dark:bg-dark-card border-b border-light-border dark:border-dark-border">
        <div className="max-w-2xl mx-auto flex items-center px-4 py-4 gap-3">
          <button
            onClick={() => navigate(businessId ? `/business/${businessId}` : '/business')}
            className="flex-shrink-0"
          >
            <ArrowLeft size={24} style={{ color: '#4F46E5' }} />
          </button>
          <h1 className="flex-1 font-bold text-light-text dark:text-dark-text truncate" style={{ fontSize: 20 }}>
            {title}
          </h1>
          {headerRight && <div className="flex-shrink-0">{headerRight}</div>}
          <ThemeToggle />
        </div>
      </div>

      <div className="max-w-2xl mx-auto pb-24">
        {children}
      </div>
    </div>
  );
};

export default BusinessPageLayout;
